import React from "react";
import "./CardServiceNew.scss";
import { Link } from "react-router-dom";

const CardServiceNew = (props) => {
  const stringtitle = props.Title;

  const shortTitle = JSON.stringify(stringtitle);

  var alert = false;

  if (shortTitle.length > 20) {
    alert = true;
  }

  return (
    <Link to={`/Post/detail/${props.id}`}>
      <div className="main_card_news">
        <div className="first_element">
          <div className="sub_stye_card">
            <div className="icons">
              <img src={props.image} alt="" />
            </div>
            <div className="frame_content">
              {alert === true ? (
                <h3>{props.Title.substring(0, 20) + "..."}</h3>
              ) : (
                <h3>{props.Title}</h3>
              )}

              <p>{props.date}</p>
            </div>
          </div>
        </div>

    
      </div>
    </Link>
  );
};

export default CardServiceNew;
